var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHorizontalElipsis(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 4,
    viewBox: "0 0 15 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.304 3.112C0.6 3.112 0.0400001 2.568 0.0400001 1.864C0.0400001 1.16 0.6 0.6 1.304 0.6C2.024 0.6 2.584 1.16 2.584 1.864C2.584 2.568 2.024 3.112 1.304 3.112ZM7.449 3.112C6.745 3.112 6.185 2.568 6.185 1.864C6.185 1.16 6.745 0.6 7.449 0.6C8.169 0.6 8.729 1.16 8.729 1.864C8.729 2.568 8.169 3.112 7.449 3.112ZM13.594 3.112C12.89 3.112 12.33 2.568 12.33 1.864C12.33 1.16 12.89 0.6 13.594 0.6C14.314 0.6 14.874 1.16 14.874 1.864C14.874 2.568 14.314 3.112 13.594 3.112Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorizontalElipsis);
export default __webpack_public_path__ + "static/media/horizontalElipsis.bb17e041.svg";
export { ForwardRef as ReactComponent };